mutation ClearOverlayLive($eventId: ID!, $overlayId: ID!, $transition: String) {
  overlay: StreamToolsClearOverlayLive(eventId: $eventId, overlayId: $overlayId, transition: $transition) {
    overlayId
    eventId
    kind
    name
    width
    height
    liveSceneId
    liveScene {
      sceneId
      name
      sourceVersion
      takenAt
      elements {
        elementKind
        elementId
        x
        y
        z
        scale
        visible
        w
        h
      }
    }
    sceneOrder
    version
    createdAt
  }
}
